module.exports = __webpack_public_path__ + "img/1.a958d40a.png";